export default "__VITE_ASSET__BmCF3Jvw__"